import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'connected-react-router'
import store, {history} from './store'

import './index.css';
import '@imprivata/common-auth-ui/build/common-auth-ui.css'
import '@imprivata/nucleus/build/nucleus.css'

ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App/>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js